<ng-select
  [searchable]="searchable"
  [items]="_options$ | async"
  [loading]="loading$ | async"
  [bindLabel]="'label'"
  [bindValue]="'value'"
  [placeholder]="placeholder"
  [(ngModel)]="selectedOption"
  [disabled]="disabled"
  [compareWith]="compareWith"
  (change)="onSelectionChange($event)"
  (focus)="searchTextFocus()"
  (blur)="searchTextBlur()"
  [typeahead]="typeahead"
  (search)="onSearch($event.term)">
  @if ((loading$ | async) === false; as item) {
    <ng-template ng-label-tmp let-item="item">
      <span>{{ item.label }}</span>
    </ng-template>
  }

  @if ((loading$ | async) === false; as item) {
    <ng-template ng-option-tmp let-item="item">
      <span>{{ item.label }}</span>
    </ng-template>
  }

  @if (itemCreation; as searchTerm) {
    <ng-template ng-header-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        Add
        <button
          type="button"
          class="btn btn-link"
          (click)="outputEvent()"
          (keydown.enter)="outputEvent()">
          Create new item "{{ searchTerm }}"
        </button>
      </div>
    </ng-template>
  }

  @if ((loading$ | async) === false && showTotals) {
    <ng-template ng-footer-tmp>
      Showing {{ loadResultsCount }} of {{ loadResultsTotal }}
    </ng-template>
  }
</ng-select>
